/**
 * Where each legal document lives as a page.
 *
 * Policies are real routes, not a sheet over another page. The three the seed
 * writes get the conventional URLs; any other document an operator adds from
 * the admin panel is still reachable at `/legal/<slug>`.
 */

const PATH_BY_SLUG: Record<string, string> = {
  'terms-of-service': '/terms-and-conditions',
  'privacy-policy': '/privacy-policy',
  'cookie-policy': '/cookie-policy',
};

const SLUG_BY_PATH: Record<string, string> = Object.fromEntries(
  Object.entries(PATH_BY_SLUG).map(([slug, path]) => [path, slug]),
);

const SLUG_SHAPE = /^[a-z0-9][a-z0-9-]{0,80}$/;

/** The page URL for a document slug. */
export function legalPath(slug: string): string {
  return PATH_BY_SLUG[slug] ?? `/legal/${encodeURIComponent(slug)}`;
}

/** The document slug a pathname is the page for, or null when it is not a legal page. */
export function legalSlugForPath(path: string): string | null {
  const known = SLUG_BY_PATH[path];
  if (known) return known;
  if (!path.startsWith('/legal/')) return null;
  let slug: string;
  try { slug = decodeURIComponent(path.slice('/legal/'.length)); } catch { return null; }
  return SLUG_SHAPE.test(slug) ? slug : null;
}

export function isLegalPath(path: string): boolean {
  return legalSlugForPath(path) !== null;
}
